import { render, staticRenderFns } from "./functional.vue?vue&type=template&id=6c7f21eb&scoped=true"
import script from "./functional.vue?vue&type=script&lang=js"
export * from "./functional.vue?vue&type=script&lang=js"
import style0 from "./functional.vue?vue&type=style&index=0&id=6c7f21eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7f21eb",
  null
  
)

export default component.exports